import axios from "axios";
import React from 'react';
import {useAlert} from "../utils/components/providers/AlertProvider";
import {useAppDispatch, useAppSelector} from "../utils/store/store";
import {getCounter, getUser, logoutUser} from "../utils/store/userSlice";
import {Utils} from "../utils/Utils";
import AdminLogin from "./modules/auth/AdminLogin";
import Dashboard from "./modules/Dashboard";


export default function App() {
    const user = useAppSelector(getUser)
    const counter = useAppSelector(getCounter)
    const dispatch = useAppDispatch()

    const {showMessage} = useAlert()

    const set_axios_data = () => {
        axios.defaults.baseURL = Utils.BASE_URL;

        axios.defaults.headers.common.Authorization = `Bearer ${user.bearerToken}`
        axios.defaults.headers.common['Content-Type'] = 'application/json'
        axios.defaults.timeout = 1000 * 60

        axios.interceptors.response.use(
            function (response) {
                //console.log(response)
                //console.log(response.data)

                if (response.data.hasOwnProperty("code")) {
                    if (response.data['code'] === 401) {
                        dispatch(logoutUser())
                        showMessage({message: "Your login session was ended previously", type: 'error'})
                    }
                }

                return response
            },
            function (error) {
                console.log(error)
                return Promise.reject(error);
            });
    }
    set_axios_data()

    return (
        <>
            {(user.userId === 0 && user.bearerToken === "") && <AdminLogin/>}

            {(user.userId !== 0 && user.bearerToken !== "") && <Dashboard/>}

            {/* Spinner Start */}
            <div id="spinner"
                 className="bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
            {/*Spinner End*/}
        </>
    )
}